import Messages from 'spark-types/Messages';
import { compose } from 'spark-util/fpUtils';
import { takeFirst, prepend } from 'spark-util/arrays';

const SEND_MESSAGE = 'MESSAGES.SEND_MESSAGE';
const CLOSE_MESSAGE = 'MESSAGES.CLOSE_MESSAGE';

export const notify = (messageType, message, messageValue) => ({
    type: SEND_MESSAGE,
    messageType,
    message, 
    messageValue
});

export const closeMessage = () => ({ type: CLOSE_MESSAGE });

const createMessageAction = messageType => (message, messageValue) => notify(messageType, message, messageValue);

export const successMessage = createMessageAction(Messages.SUCCESS);
export const warningMessage = createMessageAction(Messages.WARN);
export const alertMessage = createMessageAction(Messages.ALERT);
export const infoMessage = createMessageAction(Messages.INFO);

export const newMessageExists = state => state.message.currentMessage !== BLANK_MESSAGE;
export const getCurrentMessage = state => state.message.currentMessage;

const BLANK_MESSAGE = Object.freeze({
    messageType: {},
    text: ''
});

const initialState = {
    currentMessage: BLANK_MESSAGE,
    history: []
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SEND_MESSAGE: {
            return {
                ...state,
                currentMessage: { messageType: action.messageType, text: action.message, messageValue:action.messageValue }
            };
        }
        case CLOSE_MESSAGE: {
            return {
                currentMessage: BLANK_MESSAGE,
                history: addToRecentList(state.currentMessage, state.history)
            };
        }
        default: {
            return state;
        }
    }
};

const addToRecentList = compose(takeFirst(10), prepend);
